// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0350e519","455":"ea274b61","977":"d153253a"}[chunkId] + ".chunk.js";
};